// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class BasicEnrollmentAddress {
    static getAttributeTypeMap() {
        return BasicEnrollmentAddress.attributeTypeMap;
    }
}
BasicEnrollmentAddress.discriminator = undefined;
BasicEnrollmentAddress.additionalProperties = false;
BasicEnrollmentAddress.attributeTypeMap = [
    {
        "name": "addressOne",
        "baseName": "addressOne",
        "type": "string"
    },
    {
        "name": "addressTwo",
        "baseName": "addressTwo",
        "type": "string"
    },
    {
        "name": "city",
        "baseName": "city",
        "type": "string"
    },
    {
        "name": "state",
        "baseName": "state",
        "type": "string"
    },
    {
        "name": "zip",
        "baseName": "zip",
        "type": "string"
    },
];
//# sourceMappingURL=basicEnrollmentAddress.js.map